import React, { Fragment } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./header/Header";
import SideBar from "./sidebar/SideBar";
import BreadCrumb from "../components/BreadCrumb/BreadCrumb";

const Layout = () => {
  const location = useLocation();

  const data = location?.pathname?.split("/");
  return (
    <Fragment>
      <Header />
      {/* <BreadCrumb data={data} /> */}
      <SideBar />
      <Outlet />
    </Fragment>
  );
};

export default Layout;
